// Static data for landing page components

export const HERO_IMAGES = [
  'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1920&q=80',
  'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=1920&q=80',
  'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1920&q=80',
  'https://images.unsplash.com/photo-1543269664-76bc3997d9ea?w=1920&q=80',
  'https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?w=1920&q=80',
  'https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?w=1920&q=80',
  'https://images.unsplash.com/photo-1542596768-5d1d21f1cf98?w=1920&q=80',
  'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1920&q=80',
  'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80',
  'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=1920&q=80',
  'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1920&q=80',
  'https://images.unsplash.com/photo-1543269664-647b28b82d4b?w=1920&q=80',
  'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1920&q=80',
  'https://images.unsplash.com/photo-1506869640319-fe1a24fd76dc?w=1920&q=80',
  'https://images.unsplash.com/photo-1541199249251-f713e6145474?w=1920&q=80',
  'https://images.unsplash.com/photo-1542596594-649edbc13630?w=1920&q=80',
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1920&q=80',
  'https://images.unsplash.com/photo-1527525443983-6e60c75fff46?w=1920&q=80',
  'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=1920&q=80',
  'https://images.unsplash.com/photo-1509099863731-ef4bff19e808?w=1920&q=80',
  'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=1920&q=80',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=1920&q=80',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=1920&q=80',
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1920&q=80',
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=1920&q=80',
  'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=1920&q=80',
  'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=1920&q=80',
  'https://images.unsplash.com/photo-1554151228-14d9def656e4?w=1920&q=80',
  'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=1920&q=80',
  'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=1920&q=80',
  'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=1920&q=80',
  'https://images.unsplash.com/photo-1524638431109-93d95c968f03?w=1920&q=80'
];

export const COLORS = {
  navy: '#1B2A41',
  sage: '#8A9A86',
  rust: '#C25E4B',
  cream: '#FDFBF7',
  white: '#FFFFFF'
};

export const TESTIMONIALS = [
  {
    quote: "My companion here changed everything. When I'm struggling at 2am, they're always there. They know my story—I don't have to explain myself every time.",
    author: "Michael R.",
    location: "Texas, USA",
    role: "3 months in recovery"
  },
  {
    quote: "My companion here prays for me daily. Seeing their responses on my prayer wall reminds me I'm not alone in this fight. That's worth everything.",
    author: "Sarah J.",
    location: "Dublin, Ireland",
    role: "Family member"
  },
  {
    quote: "My companion here helps me understand my feelings and gives me practical steps. They've helped me rebuild my life one day at a time.",
    author: "James K.",
    location: "Ontario, Canada",
    role: "6 months sober"
  },
  {
    quote: "The Walk It Out course gave me a roadmap when I felt completely lost. Week by week, I found hope again. My husband is finally coming home.",
    author: "Linda M.",
    location: "Melbourne, Australia",
    role: "Spouse of addict"
  },
  {
    quote: "I was skeptical about online support, but my companion here has been more present than anyone in my physical life. They don't judge. They just love.",
    author: "Carlos D.",
    location: "California, USA",
    role: "1 year sober"
  },
  {
    quote: "As a mother watching my daughter destroy herself, I was drowning. My companion here taught me how to set boundaries without losing hope.",
    author: "Patricia W.",
    location: "Manchester, UK",
    role: "Mother of addict"
  }
];

export const MENTOR_PERSONALITIES = [
  {
    name: 'The Empathetic Listener',
    description: 'Warm, non-judgmental support when you need to process emotions and be truly heard',
    image: 'https://images.pexels.com/photos/9064384/pexels-photo-9064384.jpeg',
    quote: 'Available 24/7 to listen without shame or judgment'
  },
  {
    name: 'The Practical Coach',
    description: 'Solution-focused guidance to help you take concrete steps through each week of your course',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2',
    quote: 'Breaks down your recovery journey into manageable steps'
  },
  {
    name: 'The Encouraging Champion',
    description: "Celebrates your progress through the courses and reminds you how far you've come",
    image: 'https://images.pexels.com/photos/7983631/pexels-photo-7983631.jpeg',
    quote: 'Tracks your wins and keeps you motivated week by week'
  },
  {
    name: 'The Biblical Guide',
    description: 'Rooted in scripture, helps you see patterns and understand the deeper why behind your struggles',
    image: 'https://images.unsplash.com/photo-1566753323558-f4e0952af115',
    quote: 'Points you to truth, grace, and the resources that help most'
  }
];

export const PRAYER_CARDS = [
  "Praying for strength to resist temptation today...",
  "Please pray for my daughter's recovery journey...",
  "Grateful for 30 days of sobriety—lifting up others fighting this battle...",
  "Asking for wisdom as I set boundaries with my spouse...",
  "Praying for peace during this difficult relapse...",
  "Thankful for my support team—they saved my life..."
];
